const img = require('./banner-janeiro-2025.png');
const img2 = require('./banner1-julho2024.jpg');
const img3 = require('./banner2-julho2024.jpg');
const img4 = require('./banner-novo-agosto.jpg');
const img5 = require('./banner-novo2-2024.jpg');
const img6 = require('./banner-2-novo2-2024.jpg');
const img7 = require('./banner-3-novo2-2024.jpg');
const img8 = require('./banner-4-novo2-2024.jpg');

export const imgs = [img, img2, img3, img4, img5, img6, img7, img8];
